import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import update from "immutability-helper";
import _ from "lodash";
import validator from "validator";
import { Form, Segment, Button } from "semantic-ui-react";
import FormErrorMessage from "../../utils/FormErrorMessage";
import FormSuccessMessage from "../../utils/FormSuccessMessage";
import { resetPassword } from "../../../actions/auth";
import Dls from "../../../lib";

class ForgetPasswordForm extends Component {
    constructor() {
        super();
        this.state = {
            data: {
                email: ""
            },
            errors: [],
            loading: false,
            success_message: ""
        };
    }
    //access router
    //this.props.history.push('/dashboard')
    onEmailChange = email => {
        this.setState({
            data: update(this.state.data, {
                email: { $set: email }
            })
        });
    };

    onFormSubmit = () => {
        const errors = this.validateInput();
        if (_.isEmpty(errors)) {
            this.setState({
                loading: true
            });
            this.props
                .resetPassword(this.state.data)
                .then(res => {
                    this.setState({
                        loading: false,
                        success_message: "Please check your email, thanks",
                        errors: [],
                        data: {
                            email: ""
                        }
                    })
                })
                .catch(err => {
                    const errors = Dls.apiErrorMessage(err);
                    this.setState({
                        loading: false,
                        errors: errors
                    });
                });
        } else {
            this.setState({
                errors: errors
            });
        }
    };

    validateInput = () => {
        const { email } = this.state.data;
        const errors = [];
        if (!validator.isEmail(email)) {
            errors.push("Invalid email address");
        }
        return errors;
    };

    render() {
        return (
            <Form size="large">
                <Segment stacked>
                    {!_.isEmpty(this.state.errors) ? (
                        <FormErrorMessage errors={this.state.errors} />
                    ) : null}
                    {this.state.success_message ? <FormSuccessMessage message={this.state.success_message} /> : null}
                    <Form.Input
                        fluid
                        icon="user"
                        iconPosition="left"
                        placeholder="E-mail address"
                        value={this.state.data.email}
                        onChange={e => {
                            this.onEmailChange(e.target.value);
                        }}
                    />
                    <Button
                        color="teal"
                        fluid
                        onClick={this.onFormSubmit}
                        size="large"
                        loading={this.state.loading}
                    >
                        Get Reest Link
                    </Button>
                </Segment>
            </Form>
        );
    }
}

ForgetPasswordForm.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
    }).isRequired,
    resetPassword: PropTypes.func
};

function mapStateToProps(state) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            resetPassword
        },
        dispatch
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ForgetPasswordForm);



// WEBPACK FOOTER //
// ./src/components/forms/auth/ForgetPasswordForm.js